import { IncomingHttpHeaders } from "http";

// for www.goibibo.com
//  apache ALB set's x-goibibo-host as www.goibibo.com
//  which is available on both len-tripmoney-insurance-standalone and pay-len-krysalis service
//  apache ALB doesn't set host header
//  and hence x-forwarded-host is set to len-krysalis.ecs.mmt
// for insurance.goibibo.com, tripmoney.goibibo.com, www.makemytrip.com, insurance.makemytrip.com, tripmoney.makemytrip.com
//  krysalis set's x-forwarded-host as correct host name
//  which is available on len-tripmoney-insurance-standalone service
// Host is always set to len-tripmoney-mono-insurance-standalone.ecs.mmt for all cases

export function getHost(headers: IncomingHttpHeaders) {
  // we can get headers?.["x-goibibo-host"] as 'www.goibibo.com,www.goibibo.com' as well, hence we need to check if it includes goibibo
  // and then set it to www.goibibo.com
  let goibiboHost = headers?.["x-goibibo-host"];
  if (goibiboHost && goibiboHost.includes("goibibo")) {
    goibiboHost = "www.goibibo.com";
  }
  return goibiboHost || headers?.["x-forwarded-host"] || headers?.["host"];
}
